import { render, staticRenderFns } from "./BaseDetailInputGroup.vue?vue&type=template&id=2f373f4c&scoped=true&"
import script from "./BaseDetailInputGroup.vue?vue&type=script&lang=js&"
export * from "./BaseDetailInputGroup.vue?vue&type=script&lang=js&"
import style0 from "./BaseDetailInputGroup.vue?vue&type=style&index=0&id=2f373f4c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f373f4c",
  null
  
)

export default component.exports